import { FlightDeal, FlightDealDuration } from 'components/Flights/types'

function flightDealDurationMap(duration): FlightDealDuration {
  return {
    departureDate: duration.departureDate,
    arrivalDate: duration.arrivalDate,
  }
}

export function flightDealMap(deal): FlightDeal {
  return {
    id: deal.id,
    carrierLogo: deal.carrierLogo,
    carrierCode: deal.carrierCode,
    originAirportCode: deal.originAirportCode,
    originAirportName: deal.originAirportName,
    destinationAirportCode: deal.destinationAirportCode,
    destinationAirportName: deal.destinationAirportName,
    fareType: deal.fareType,
    fareClass: deal.fareClass.toLowerCase(),
    offerDuration: deal.offerDuration.map(duration => flightDealDurationMap(duration)),
    salesStartDate: deal.salesStartDate,
    salesEndDate: deal.salesEndDate,
    perAdultPrice: deal.perAdultPrice,
    discountLabel: deal.discountLabel,
    adultCount: deal.adultCount,
    dealName: deal.dealName,
  }
}
